import React from "react";


export function Paso({texto}){

    return(
        <div>
            {texto && texto}
            <br/>
            <br/>
        </div>
    )
}